import Layout from '@/modules/layout/components/layout';
import routes from '@/modules/layout/layout-routes';
import store from '@/modules/layout/layout-store';
import layoutGuardMixin from './guards/layout-guard-mixin';

export default {
    components: [Layout],
    filters: [],
    mixins: [layoutGuardMixin],
    routes,
    store,
};
